/**
 * Which articles each service and industry page links to under "Further
 * reading". Before this the older articles were linked only from /articles,
 * and Google left most of them as "Discovered – currently not indexed".
 *
 * Keys are service or industry slugs; values are article route segments
 * (/articles/<id>), most relevant first. Every article should appear at
 * least once.
 */
export const SERVICE_ARTICLES = {
  'ai-development': ['mlRoadmap', 'aiDevelopmentCost', 'mlOutRails'],
  'generative-ai': ['genAi', 'ragVsFineTuning', 'measureAiAssistant'],
  rag: ['ragVsFineTuning', 'measureAiAssistant', 'genAi'],
  'rag-proof-of-concept': ['ragVsFineTuning', 'measureAiAssistant', 'aiProjectBrief'],
  'ai-agents': ['chatbotVsAgent', 'aiChatbots', 'measureAiAssistant'],
  'computer-vision': ['computerVision', 'aiInArchitect', 'mlrolehealth'],
  'nlp-chatbots': ['aiChatbots', 'chatbotVsAgent', 'georgianSpeechAi'],
  'georgian-language-ai': ['georgianSpeechAi', 'aiTeamGeorgia', 'aiChatbots'],
  'data-engineering': ['dataPrivacy', 'mlEcommerce', 'mlOutRails'],
  mlops: ['mlOutRails', 'mlRoadmap', 'measureAiAssistant'],
  'web-development': ['digitalHealth', 'aiProjectBrief'],
  'mobile-development': ['aiDepressive', 'digitalHealth'],
  'nearshore-ai-development-europe': ['aiTeamGeorgia', 'aiDevelopmentCost', 'aiProjectBrief'],
  'ai-consulting': ['aiProjectBrief', 'mlRoadmap', 'dataPrivacy'],
}

export const INDUSTRY_ARTICLES = {
  healthcare: ['mlrolehealth', 'moralRiskHealth', 'aiDepressive', 'digitalHealth'],
  'architecture-construction': ['aiInArchitect', 'computerVision'],
  fintech: ['dataPrivacy', 'mlOutRails'],
  'ecommerce-retail': ['mlEcommerce', 'aiChatbots'],
}

// Titles of the older articles, which have their own page files rather than
// an entry in data/articles.js: route segment → locale key.
export const LEGACY_ARTICLE_TITLE_KEYS = {
  aiChatbots: 'BlogAiChatbots',
  mlRoadmap: 'BlogMlRoadmap',
  computerVision: 'BlogComputerVision',
  digitalHealth: 'BlogDigitalHealth',
  genAi: 'BlogGenAi',
  dataPrivacy: 'BlogDataPrivacy',
  mlEcommerce: 'BlogMlEcommerce',
  mlrolehealth: 'BlogmlroleHealth',
  aiInArchitect: 'BlogaiinArchitect',
  moralRiskHealth: 'Blogmoralrisk',
  aiDepressive: 'Blogaidepressivemain',
  mlOutRails: 'BlogmlFails',
}
